export const updateStickyHeader = (className) => {
  const el = document.querySelector('.Header3');
  if (el) el.classList.add(className);
};

export const chunkArray = (arr, chunkSize) => {
  const chunkedArr = [];

  for (let i = 0; i < arr.length; i += chunkSize) {
    chunkedArr.push(arr.slice(i, i + chunkSize));
  }

  return chunkedArr;
}
